import DOMPurify from 'dompurify';
import { mountImageBatch } from './image-batch-queue.js';
import { imageIsAr, imageName } from './image-batch-utils.js';
import { trackEvent } from '../core/analytics.js';

const t = (ar, en) => imageIsAr ? ar : en;
mountImageBatch({
  rootId: 'svg-sanitizer-app', accept: '.svg,image/svg+xml',
  fields: [{
    key: 'removeTitles',
    label: t('إزالة عناوين SVG', 'Remove SVG titles'),
    type: 'segmented',
    span: 'full',
    default: 'yes',
    options: [
      { value: 'yes', label: t('نعم، تنظيف كامل وحذف العناوين', 'Yes, thorough cleanup & strip titles') },
      { value: 'no', label: t('الاحتفاظ بالعناوين', 'Keep titles') }
    ]
  }],
  zipName: 'sanitized-svg-files.zip',
  process: async (file, settings, report) => {
    report(8, t('جارٍ قراءة SVG', 'Reading SVG'));
    const raw = await file.text();
    const original = new DOMParser().parseFromString(raw, 'image/svg+xml');
    if (original.querySelector('parsererror') || original.documentElement.localName !== 'svg') throw new Error(t('ملف SVG غير صالح.', 'Invalid SVG markup.'));
    const count = (root) => root.querySelectorAll('*').length + Array.from(root.querySelectorAll('*')).reduce((sum, node) => sum + node.attributes.length, 0);
    const originalCount = count(original);
    report(35, t('إزالة العناصر والسمات الخطرة', 'Removing unsafe elements and attributes'));
    const clean = DOMPurify.sanitize(raw, { USE_PROFILES: { svg: true, svgFilters: false }, RETURN_TRUSTED_TYPE: false, ALLOW_DATA_ATTR: false, FORBID_TAGS: ['script', 'style', 'foreignObject', 'iframe', 'object', 'embed', 'image'], FORBID_ATTR: ['style'] });
    const parsed = new DOMParser().parseFromString(clean, 'image/svg+xml');
    const root = parsed.documentElement;
    if (!root || root.localName !== 'svg' || parsed.querySelector('parsererror')) throw new Error(t('تعذر تنظيف SVG بأمان.', 'The SVG could not be sanitized safely.'));
    if (settings.removeTitles === 'yes') root.querySelectorAll('title,desc').forEach((node) => node.remove());
    root.querySelectorAll('metadata').forEach((node) => node.remove());
    root.querySelectorAll('g').forEach((g) => { if (!g.children.length && !g.textContent.trim()) g.remove(); });
    let externalLinks = 0;
    for (const node of [root, ...root.querySelectorAll('*')]) for (const attribute of [...node.attributes]) {
      if (/^(?:href|xlink:href)$/i.test(attribute.name) && !attribute.value.trim().startsWith('#')) { node.removeAttribute(attribute.name); externalLinks++; }
      if (/^(?:inkscape:|sodipodi:|sketch:|xmlns:)/i.test(attribute.name) && !attribute.name.includes('xlink') && !attribute.name.includes('svg')) {
        node.removeAttribute(attribute.name);
      }
    }
    let output = new XMLSerializer().serializeToString(root);
    output = output.replace(/<!--[\s\S]*?-->/g, '').replace(/\s{2,}/g, ' ').trim();
    const blob = new Blob([output], { type: 'image/svg+xml;charset=utf-8' });
    report(100, t('اكتمل التنظيف الآمن', 'Safe cleanup complete'));
    trackEvent('tool_completed', 'svg-sanitizer', { input_bytes: file.size, output_bytes: blob.size, external_links_removed: externalLinks });
    const outFilename = `${imageName(file.name)}.svg`;
    return { blob, filename: outFilename, details: `${(file.size / 1024).toFixed(1)} KB → ${(blob.size / 1024).toFixed(1)} KB · ${Math.max(0, originalCount - count(parsed)) + externalLinks} ${t('عنصر/سمة أزيل', 'elements/attributes removed')}` };
  }
});
